import type {
  CardChart,
  ChartCard,
  TableData,
} from '@/features/dashboard/api/schemas'
import { isTableCard } from './deepDiveKind'
import { categoryLabels, secondaryFormat } from './deepDiveModel'
import { metricSeries, referenceSeries, seriesLabel } from './series'

/** A chart's figures for 'View as table': a row per category, a column per series; null if there is nothing to list. */
export const chartToTable = (
  card: ChartCard,
  chart: CardChart | null | undefined
): TableData | null => {
  if (isTableCard(card, chart) || card.categories.length === 0) return null
  const series = [...metricSeries(card.series), ...referenceSeries(card.series)]
  if (series.length === 0) return null
  const labels = categoryLabels(card, chart)

  return {
    columns: series.map((entry, i) => ({
      id: `series-${i}`,
      label: seriesLabel(entry.name),
      kind: 'value' as const,
      format: entry.axis === 'secondary' ? secondaryFormat(card) : card.format,
    })),
    rows: labels.map((label, row) => ({
      id: `row-${row}`,
      label,
      level: 0 as const,
      kind: 'row' as const,
      cells: series.map(entry => entry.data[row] ?? null),
    })),
  }
}
